import { Outlet } from 'react-router';

import { FloatingNavBar, Header } from '@/components/common';

import glassBg from '@/assets/images/glass-bg.png';

const MainLayout = () => {
  return (
    <div className="relative flex flex-col min-h-screen bg-[radial-gradient(100%_134.54%_at_100%_4.15%,#F3F6F8_0%,#F3F6F8_9.02%,#F0F2FB_15.42%,#F0F2FB_19.36%,#EBF0F9_48.12%,#F3F6F8_69.68%,#F3F6F8_100%)] overflow-hidden">
      <img
        src={glassBg}
        alt=""
        className="absolute top-0 -right-[500px]  mix-blend-color-burn pointer-events-none h-[430px] rotate-[32deg]"
      />
      <Header />
      <main className="flex-1 relative">
        <div className="mx-6 mt-6 mb-[124px]">
          <Outlet />
        </div>
      </main>
      <FloatingNavBar />
    </div>
  );
};

export { MainLayout };
